import { createStore, applyMiddleware, Store, Middleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import logger from 'redux-logger';
import env from '@utils/env';
import { IAppState } from './types';
import authSagas from './auth/sagas';
import dsConnfigSagas from './dsconfig/sagas';
import templatesSagas from './templates/sagas';
import parsedTreesSagas from './parsedTrees/sagas';
import designsSagas from './designs/sagas';
import foldersSagas from './folders/sagas';
import userFilesSagas from './userFiles/sagas';
import userConfigSagas from './userConfig/sagas';
import storageSagas from './storage/sagas';
import dealersSagas from './dealers/sagas'
import brandsSagas from './brands/sagas'
import brandsImagesSagas from './brandsImages/sagas'
import userAccessSagas from './userAccess/sagas'
import industriesSagas from './industries/sagas'
import reducers from './reducers';

const sagaMiddleware = createSagaMiddleware();
const middleware: Middleware[] = [sagaMiddleware];
if (env === 'dev') {
  // middleware.push(logger);
}

const configureStore = () => {
  let store: Store<IAppState>;
  store  = createStore(reducers, applyMiddleware(...middleware)) as Store<IAppState>;
  
  sagaMiddleware.run(authSagas);
  sagaMiddleware.run(dsConnfigSagas);
  sagaMiddleware.run(templatesSagas);
  sagaMiddleware.run(parsedTreesSagas);
  sagaMiddleware.run(designsSagas);
  sagaMiddleware.run(foldersSagas);
  sagaMiddleware.run(userFilesSagas);
  sagaMiddleware.run(userConfigSagas);
  sagaMiddleware.run(storageSagas);
  sagaMiddleware.run(dealersSagas);
  sagaMiddleware.run(brandsSagas);
  sagaMiddleware.run(brandsImagesSagas);
  sagaMiddleware.run(userAccessSagas);
  sagaMiddleware.run(industriesSagas);
  return store;
};

export default configureStore;
